import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import { DayPicker, ClassNames, DayContentProps, DateFormatter, CaptionProps } from 'react-day-picker';

import CalendarCell from './calendar/calendarCell';
import CalendarHeader from './calendar/calendarHeader';
import { getEventForCurrentDay } from './common/helpers';

import { AvailabilityObject, IntervalsObject } from '../../../interfaces/meeting';
import LoadingComponent from '../../common/loadingComponent';

const classNames: ClassNames = {
  head: 'custom-head',
  head_row: 'custom-row',
};

interface CalendarViewProps {
  view: string;
  loading: boolean;
  availability: AvailabilityObject[];
  setOpenAvailability: (date: string, open: boolean, intervals: IntervalsObject[]) => void;
  setMonthYear: (value: string) => void
}

const formatWeekdayName: DateFormatter = (date, options) => (
  <Typography sx={{
    textTransform: 'uppercase',
    fontSize: '16px',
    color: '#878787',
    fontWeight: 600,
  }}>
    {format(new Date(date), 'EEEE', { locale: options?.locale })}
  </Typography>
);


const CalendarView = ({
  view,
  loading,
  availability,
  setOpenAvailability,
  setMonthYear,
}: CalendarViewProps) => {

  return (
    <Box>
      {view === 'calendar' &&
        <DayPicker
          classNames={classNames}
          styles={{
            table: {
              width: '100%',
            },
            head_row: {
              display: 'grid',
              gridTemplateColumns: 'repeat(7, 1fr)',
            },
            row: {
              display: 'grid',
              gridTemplateColumns: 'repeat(7, 1fr)',
            },
          }}
          formatters={{ formatWeekdayName }}
          components={{ 
            Caption: (props : CaptionProps) => (
              <CalendarHeader 
                setCurrentMonth={setMonthYear}
                {...props}
              />
            ),
            DayContent: (props : DayContentProps) => (
              <CalendarCell 
                {...props}
                setAvailability={setOpenAvailability}
                events={getEventForCurrentDay(availability, props?.date?.toString())}
              />
            ),
          }}
          showOutsideDays 
        />
      }
      {loading && <LoadingComponent size={20}/>}
    </Box>
  );
};

export default CalendarView;